import { queryOptions, useQuery } from "@tanstack/react-query";
import { api } from "../apiClient";

// Get all bus schedules
export const getBusSchedules = params => {
  return api.get("admin/bus-schedules-v2", {
    params,
  });
};

export const getBusSchedulesQueryOptions = params => {
  return queryOptions({
    queryKey: ["bus-schedules", params],
    queryFn: () => getBusSchedules(params),
  });
};

export const useBusSchedulesQuery = ({ queryConfig = {}, ...params }) => {
  return useQuery({
    ...getBusSchedulesQueryOptions(params),
    ...queryConfig,
  });
};
